import { useCallback, useEffect, useState } from "react"
import { MessageCircle, Sparkles } from "lucide-react"

import "./haptik-chat-fab.css"

const HAPTIK_HIDE_EVENT = "haptikchat:windowhide"

/**
 * Custom launcher for Haptik (custom-button: true in index.html).
 * Toggles chat panel via window.HaptikSDK.expandWidget / hide.
 */
export function HaptikChatFab() {
  const [chatOpen, setChatOpen] = useState(false)

  useEffect(() => {
    const onSdkHide = () => setChatOpen(false)
    window.addEventListener(HAPTIK_HIDE_EVENT, onSdkHide)
    return () => window.removeEventListener(HAPTIK_HIDE_EVENT, onSdkHide)
  }, [])

  const handleClick = useCallback(() => {
    const sdk = window.HaptikSDK
    if (!sdk) return

    if (chatOpen) {
      sdk.hide?.()
      setChatOpen(false)
      return
    }

    if (typeof sdk.expandWidget === "function") {
      sdk.expandWidget()
      setChatOpen(true)
    }
  }, [chatOpen])

  return (
    <button
      type="button"
      className="haptik-chat-fab"
      onClick={handleClick}
      aria-label={chatOpen ? "Close chat" : "Open chat"}
      aria-expanded={chatOpen}
    >
      <span className="haptik-chat-fab__pulse" aria-hidden="true" />
      <span className="haptik-chat-fab__disc">
        <MessageCircle
          className="haptik-chat-fab__message-icon"
          strokeWidth={2}
          aria-hidden="true"
        />
        <span className="haptik-chat-fab__sparkle-wrap" aria-hidden="true">
          <Sparkles className="haptik-chat-fab__sparkle-icon" strokeWidth={2} />
        </span>
      </span>
      <span className="haptik-chat-fab__tooltip" aria-hidden="true">
        Need help? Chat with us
      </span>
    </button>
  )
}
